import { render, staticRenderFns } from "./StatisticsSection.vue?vue&type=template&id=51aa73d8&scoped=true&"
import script from "./StatisticsSection.vue?vue&type=script&lang=js&"
export * from "./StatisticsSection.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsSection.vue?vue&type=style&index=0&id=51aa73d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa73d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
